import React, { useState } from 'react';
import './FAQ.css';
import Balao from '../../assets/imgs/pensamento.svg';

import Angle from '../../assets/imgs/pure-angle.svg';
const Faq = ({onScroll}) => {
  const [expanded, setExpanded] = useState(null);

  const toggleAccordion = (index) => {
    if (expanded === index) {
      setExpanded(null);
    } else {
      setExpanded(index);
    }
  };

  const faqItems = [
    {
      question: 'Serve para qualquer tipo de trabalho acadêmico?',
      answer:
        'Claro que sim! O livro e a plataforma abordam, juntos, todo o conteúdo relacionado à pesquisa científica, além de fornecer modelos, guias e dicas relacionados aos principais trabalhos acadêmicos.',
    },
    {
      question: 'Serve para qualquer curso e área do conhecimento?',
      answer:
        'Embora o conteúdo seja direcionado para a área jurídica, a Insigne Acadêmica já testou a funcionalidade do livro e da plataforma com mais de 200 alunos (entre os cursos das áreas da saúde, exatas e sociais). Você vai notar que a pesquisa científica só tem um caminho e, quando compreendê-lo, você conseguirá desenvolver uma pesquisa em qualquer área, mesmo que não seja a sua.',
    },
    {
      question: 'Em quanto tempo posso terminar a minha pesquisa?',
      answer:
        'No tempo que você quiser e que se adequar à sua rotina. Já tivemos alunos terminando uma monografia de 60 páginas em 1 semana, um artigo de 20 páginas em 3 dias, uma dissertação de mestrado de 150 páginas em menos de 1 mês e por aí vai. As possibilidades são infinitas. Pesquisar é simples, você verá.',
    },
    {
      question: 'Eu não tenho tempo o suficiente para aprender tudo.',
      answer:
        'Você não precisa de tempo, até porque as orientações presentes no livro e na plataforma são objetivas, simples e direto ao ponto. Depois que compreender as etapas da pesquisa científica, é possível que você comece a pesquisar até mesmo no caminho da sua casa (no ônibus, certo? Não pesquise se estiver dirigindo).',
    },
    {
      question: 'Serve para graduação, especialização, mestrado e doutorado?',
      answer:
        'Claro que sim! A pesquisa científica é a mesma, não importa a sua titulação, a diferença é apenas a quantidade de páginas e a complexidade, mas o processo é o mesmo.',
    },
    {
      question: 'O professor Pedro irá revisar o meu trabalho?',
      answer:
        'Ele pode revisar o seu trabalho caso você contrate outros serviços, como o de Mentoria, pois, nesse caso, o professor Pedro irá acompanhar você, dia após dia, até você finalizar sua pesquisa.',
    },
    {
      question: 'Por quanto tempo terei acesso a essa plataforma?',
      answer:
        'Inicialmente, você terá acesso de 6 meses à plataforma, até porque, no momento, ela é um bônus devido à aquisição do livro. Isso significa que você poderá acompanhar todo o desenvolvimento e inserção do conteúdo na plataforma pelo valor pago pelo livro agora neste momento.',
    },
    {
      question: 'Posso renovar meu acesso à plataforma?',
      answer:
        'Claro que sim! Depois dos 6 meses, quando a plataforma estiver lotada de conteúdo, o valor será alterado para novos alunos, mas, aqueles que estão com a gente desde o início (como você), terão condições especiais caso queiram permanecer.',
    },
    {
      question: 'Quando eu adquirir o acesso, posso compartilhar com outra pessoa?',
      answer:
        'Por quê? O acesso o seu. Você quer compartilhar com outra pessoa? Não, não. Além de essa conduta ser crime, todo o acesso é rastreado e todos os materiais são gerados com os seus dados. Não compartilhe, tá bom? (Sério).',
    },
    {
      question: 'Como eu acesso a plataforma?',
      answer:
        'Você receberá todas as instruções por e-mail ou por whatsapp, não se preocupe. Essa é a parte mais simples.',
    },
  ];

  return (
    <div className="faq-container">
      <h2>Dúvidas frequentes do pessoal</h2>
      <div className='purple-shape'><img alt='insigne' src={Balao}></img>que também podem ser as suas</div>
      {faqItems.map((item, index) => (
        <div key={index} onClick={() => toggleAccordion(index)} className="faq-item">
          <div
            className={`faq-question ${expanded === index ? 'expanded' : ''}`}
           
          >
            <h3>{item.question}</h3>
            <span>{expanded === index ? <img className='rotated-img' alt='insigne' src={Angle}></img> : <img alt='insigne' src={Angle}></img>}</span>
          </div>
          {expanded === index && (
            <div className="faq-answer">
              <p>{item.answer}</p>
            </div>
          )}
        </div>
      ))}
      <button onClick={onScroll} className="main-btn alt">ENTENDI TUDO! E QUERO TER ACESSO!</button>
    </div>
  );
};

export default Faq;
